import * as React from 'react'
import { translateWithUserLocale } from '../utils/i18n'

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Icon,
} from '@design/pt-ui'

export interface DialogCustomization {
  title?: string
  yes?: string
  no?: string
  message?: React.JSX.Element | string
}

export interface IProps extends DialogCustomization {
  open: boolean
  onConfirm: () => void
  onClose: () => void
}

function ConfirmationDialog(props: IProps) {
  const title =
    props.title || translateWithUserLocale('confirmation_dialog.are_you_sure')
  return (
    <div>
      <Dialog
        disableRestoreFocus={true}
        open={props.open}
        onClose={props.onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>

        {props.message ? (
          <DialogContent>
            <Box
              sx={{
                display: 'flex',
                flexFlow: 'row',
                justifyContent: 'center',
              }}>
              <div>{props.message}</div>
            </Box>
          </DialogContent>
        ) : null}
        <DialogActions>
          <Button
            className="cp-confirm-no"
            onClick={props.onClose}
            color="inherit">
            <Icon sx={{ fontSize: 44, color: 'red', mr: 2 }}>cancel</Icon>
            {props.no || translateWithUserLocale('no')}
          </Button>

          <Button
            className="cp-confirm-yes"
            onClick={props.onConfirm}
            color="inherit">
            <Icon sx={{ fontSize: 44, color: '#57ac40', mr: 2 }}>
              check_circle
            </Icon>
            {props.yes || translateWithUserLocale('yes')}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default ConfirmationDialog
